import { DataSet } from 'libs/end-to-end/src/types/databases/data-sets/data-set';
import { z } from 'zod';

export const CreateOrUpdateDataSetSchema = DataSet.omit({
  id: true,
});

export type CreateOrUpdateDataSetRequestBodyType = z.infer<
  typeof CreateOrUpdateDataSetSchema
>;
